export const useUser = () => {
    const client = useCookie('uogorod.client', {
        watch: 'shallow',
        readonly: true
    });

    return client;
}
